import { render } from "./404.vue?vue&type=template&id=912c7e4a&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=912c7e4a&scoped=true&lang=scss"

import exportComponent from "D:\\Domain\\repos\\quizup.top\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-912c7e4a"]])

export default __exports__